import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FaSignInAlt, FaUserPlus, FaTachometerAlt, FaUserShield, FaSignOutAlt } from 'react-icons/fa';

const Navbar = ({ user, onLogout }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const NavItem = ({ to, icon, children }) => (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `relative flex items-center px-4 py-2 rounded-lg text-sm font-semibold transition-all duration-300 ease-in-out
         ${isActive
           ? 'text-white bg-white bg-opacity-20 shadow-inner'
           : 'text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10'
         } transform hover:scale-105`
      }
    >
      {icon}
      <span className="ml-2">{children}</span>
    </NavLink>
  );

  return (
    <nav
      className={`sticky top-0 z-50 transition-all duration-300 ease-in-out animate-fadeInUp
                 ${scrolled ? 'glass shadow-2xl' : 'bg-transparent'}`}
    >
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <Link to="/" className="text-3xl font-bold gradient-text tracking-wider">
              KRUKSHOP
            </Link>
          </div>
          <div className="flex items-center space-x-2">
            {user ? (
              <>
                <NavItem to="/dashboard" icon={<FaTachometerAlt />}>Panel</NavItem>
                {user.role === 'admin' && (
                  <NavItem to="/admin" icon={<FaUserShield />}>Admin</NavItem>
                )}
                {user.role === 'user' && (
                  <NavItem to="/create-shop">Stwórz Sklep</NavItem>
                )}
                <div className="flex items-center pl-4">
                  <span className="text-gray-300 text-sm mr-4">Witaj, <span className="font-semibold text-white">{user.email}</span></span>
                  <button
                    onClick={onLogout}
                    className="btn-secondary flex items-center !px-4 !py-2 text-sm"
                  >
                    <FaSignOutAlt className="mr-2" />
                    Wyloguj się
                  </button>
                </div>
              </>
            ) : (
              <>
                <NavItem to="/login" icon={<FaSignInAlt />}>Login</NavItem>
                <Link to="/register">
                  <button className="btn-primary flex items-center !px-4 !py-2 text-sm">
                    <FaUserPlus className="mr-2" />
                    Register
                  </button>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
